/**
 * Core – Main menu (shared across all projects)
 */

export default {
  menu: {
    home: "Home",
    stores: "Stores",
    transactions: "Transactions",
    vatRet: "VAT",
    taxSettings: "Settings",
    vatReg: "VAT Registration",
    taxAudit: "Tax Audit",
    taxAcademy: "Tax Academy",
    invite: "Invite & earn 15€",
    support: "Support",
    billing: "Billing",
    logOut: "Log out",
    dashboard: "Dashboard",
    salesTax: "Sales TAX",
    eprReporting: "EPR",
    packagingSku: "Packaging SKU",
    reports: "Reports",
    reportCalendar: "Report Calendar",
    messages: "Messages",
    helpCenter: "Help center",
    clients: "Clients",
    otherLovatApps: "Other Lappa Apps",
    selectLovatApp: "Select a Lappa App",
    globalSettingsTooltip: "Global settings",
    changeCompanyTooltip: "Change company",
    notificationCenterTooltip: "Notification center",
    switchingApp: "Switching app...",
    switchingAppLabel: "Switching app",
    manageApplications: "Manage L'Applications",
    sessionExpiredLoginAgain: "Session expired or unauthorized. Please log in again.",
    failedToSwitchApp: "Failed to switch app. Please try again.",
  },
};
